// @see mylw-nxstaging.nexcess-internal.workers.dev
import stagingTemplate from './staging';
import type { AppConfigI } from './example';

const nxstaging: AppConfigI = {
	...stagingTemplate,
	hosts: {
		...stagingTemplate.hosts,
		www: 'stg-marketing.nexcess.com',
	},
	gaTrackerId: 'G-1TWF0K1664',
	gtmContainerId: 'GTM-P63QM29T',
	cart: {
		checkoutURL: 'https://stg-marketing.nexcess.com/cart/checkout',
		configURL: 'https://stg-marketing.nexcess.com/configuration',
		cookieDomain: 'nexcess.com',
		payPalSystem: 'portal_nx',
		payPalSignUpSystem: 'portal_signup_nx',
	},
	openId: {
		...stagingTemplate.openId,
		client_id: 'nx-portal',
		authority: 'https://login.staging.nexcess.com',
	},
	theme: 'nexcess',
	brand: 'nexcess',
};

export default nxstaging;
